import '../main.css';
import './Navbar.css';

const Navbar= () =>{
    return (
        <div >
            <header className="vertical">
                <div className="left">
                    <div className="text">erika yang</div>
                </div> 
            </header>
                
        </div>
    )
}

export default Navbar;